var moment = require('moment');

var React = require('react');

var AttributeTable = require('../AttributeTable');
var Constants = require('../../constants/Constants');
var Currency = require('../../util/Currency');
var DateRange = require('../../util/DateRange');

var Accounting = React.createClass({
    propTypes: {
        service: React.PropTypes.object.isRequired
    },

    statics: {
        accountingShouldDisplay: function (service) {
            return !!service.accounting;
        }
    },

    render: function () {
        var service = this.props.service;
        var accounting = service.accounting;

        var attributes = [];

        if (service.underContractUntil) {
            attributes.push({
              name: 'Under Contract Until',
              value: moment(service.underContractUntil).format(_DATE_FORMAT)
            })
        }

        if (accounting.date_last_invoiced) {
            attributes.push({
                name: 'Last Invoice Sent',
                value: moment(accounting.date_last_invoiced).format(_DATE_FORMAT)
            });
        }
        if (accounting.date_next_invoice) {
            attributes.push({
                name: 'Next Invoice',
                value: moment(accounting.date_next_invoice).format(_DATE_FORMAT)
            });
        }
        if (accounting.interval_price) {
            let value = Currency.format(accounting.interval_price) + " / " + DateRange.simpleFormat(accounting.interval)

            if (service.offer && service.coupon) {
                value = (
                  <div>
                      <div style={{ textDecoration: 'line-through' }}>
                          {Currency.format(service.offer.recurringAmount) + " / " + DateRange.simpleFormat(accounting.interval)}
                      </div>
                      <div>
                          {value}
                      </div>
                  </div>
                )
            }

            attributes.push({
              name: 'Price',
              value
            })
        }
        if (service.coupon) {
            attributes.push({
              name: 'Applied Coupon',
              value: service.coupon.name
            })
        }

        var disable;
        if (service.authentication && service.authentication.active_disable) {
            disable = <div key="shaped-offpeak" className="alert alert-danger">
                Your service has been suspended due to non payment of invoices.
            </div>;
        }

        return <section>
            {disable}
            <AttributeTable attributes={attributes} />
        </section>;
    }
})
module.exports = Accounting;



// WEBPACK FOOTER //
// ./app/components/ClientService/Accounting.js